export default __webpack_public_path__ + "static/media/cv.6239fabe.png";